module.exports = __webpack_public_path__ + "static/media/Unearthing-the-Value-of-Brand-Car-Wreckers.4af781a7.jpg";